import { queryOptions, useQuery } from '@tanstack/react-query'

import { getAnalyticsOverview } from './api'
import type { AnalyticsWindowOption } from './types'

export function analyticsOverviewQueryOptions(tenantId: string, days: AnalyticsWindowOption) {
  return queryOptions({
    queryKey: ['analytics', tenantId, 'overview', days] as const,
    queryFn: () => getAnalyticsOverview(tenantId, days),
    // Metricas nao precisam de tempo real; um refetch por navegacao/foco basta.
    staleTime: 30_000,
  })
}

export function useAnalyticsOverview(tenantId: string | undefined, days: AnalyticsWindowOption) {
  return useQuery({
    ...analyticsOverviewQueryOptions(tenantId ?? '', days),
    enabled: tenantId !== undefined,
  })
}
